import CreationToolCutOutMode from 'creation/src/creation-tools/types/cut-out-mode'
import { Path, Point } from './cut-out-context'

export const POINT_SIZE_SCALE = 40

export const getDifferenceBetweenTwoPoints = (point1: Point, point2: Point): Point => {
    const x = Math.abs(point1.x - point2.x)
    const y = Math.abs(point1.y - point2.y)
    return { x, y }
}

export const lerp = (point1: Point, point2: Point, t: number): Point => {
    return {
        x: point1.x + (point2.x - point1.x) * t,
        y: point1.y + (point2.y - point1.y) * t,
    }
}

// Spec §12.4: legacy computes x as `pageX - rect.left` and y as
// `pageY - rect.top - documentElement.scrollTop`. The y form reduces to
// `clientY - rect.top`; the x form omits the matching scrollLeft subtraction
// and drifts once the page is scrolled horizontally. Client coordinates are
// viewport-relative and immune to both scroll axes.
export const pointFromEvent = (e: { clientX: number; clientY: number }, target: Element, scale: number): Point => {
    const { left, top } = target.getBoundingClientRect()
    return {
        x: (e.clientX - left) * scale,
        y: (e.clientY - top) * scale,
    }
}

export const drawPoint = (
    canvas: HTMLCanvasElement,
    path: Path,
    point: Point,
    sourceImage: HTMLImageElement,
    scale: number
) => {
    const context = canvas.getContext('2d')

    if (!context) {
        return
    }

    context.save()

    if (path.mode === CreationToolCutOutMode.Erase) {
        context.globalCompositeOperation = 'destination-out'
        context.beginPath()
        context.arc(point.x, point.y, path.size * scale, 0, 2 * Math.PI)
        context.fill()
    }

    if (path.mode === CreationToolCutOutMode.Paint) {
        context.globalCompositeOperation = 'source-over'
        context.beginPath()
        context.arc(point.x, point.y, path.size * scale, 0, 2 * Math.PI)
        context.clip()
        sourceImage && context.drawImage(sourceImage, 0, 0)
    }

    context.restore()
}

export const getFileImageElement = async (file: File): Promise<HTMLImageElement> => {
    return new Promise((resolve) => {
        const reader = new FileReader()

        reader.addEventListener(
            'load',
            () => {
                // convert image file to base64 string

                const imageObj = new Image()
                imageObj.onload = function () {
                    resolve(imageObj)
                }

                imageObj.src = reader.result as string
            },
            false
        )

        reader.readAsDataURL(file as Blob)
    })
}
